import styles from "@website/ui-old/top-app-bar/top-app-bar.module.scss";
import { TopAppBarPropertiesType } from "@website/ui-old/top-app-bar/top-app-bar.types";
import { FC, memo } from "react";

const TopAppBar: FC<TopAppBarPropertiesType> = (properties) => {
  const { StartAction, title, EndLayout, fixed = false, style } = properties;

  return (
    <div
      className={`${styles["container"]} ${fixed ? styles["fix"] : ""}`}
      data-testid="top-app-bar"
      style={style}
    >
      {StartAction}
      <div className={styles["title"]} data-testid="top-app-bar-title">
        {title}
      </div>
      <div className={styles["end-layout"]}>{EndLayout}</div>
    </div>
  );
};

const TopAppBarMemoized = memo(TopAppBar);
/**
 * @deprecated please use @website/ui instead
 */
export {
  /**
   * @deprecated please use @website/ui instead
   */
  TopAppBarMemoized /**
   * @deprecated please use @website/ui instead
   */ as TopAppBar
};
